export default __webpack_public_path__ + "static/ilustration-2-12d19b5da507ae0c7aa72e2f1c68a419.png";